<template>
    <div>
        <div class="container">
            <PageIntro :title="$t('pages.registration.title')" :subtitle="$t('pages.registration.subtitle')" />
        </div>

        <RegistrationStepperSection />
    </div>
</template>

<script>
import RegistrationStepperSection from '~/components/Sections/RegistrationStepperSection';

export default {
    name: 'Registration',
    components: {
        RegistrationStepperSection,
    },
};
</script>
